var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "7px",
    viewBox: "0 0 13 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tags/Passcode",
    transform: "translate(-4.000000, -12.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Key_760934"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.55729689,13.2938619 C6.06561214,13.2938619 5.66689702,13.6925673 5.66593857,14.1826428 L5.66593857,16.2103538 C5.66689702,16.6991513 6.06561214,17.0978567 6.55537999,17.0981762 C7.04514785,17.0981762 7.44354368,16.6991513 7.44354368,16.2090759 L7.44354368,14.1816843 C7.44386297,13.6922479 7.0461063,13.2938619 6.55729689,13.2938619 Z M16.2925911,18.1182615 C16.2925911,18.3827872 16.0778984,18.5974748 15.8133662,18.5974748 C15.5488341,18.5974748 15.3341413,18.3827872 15.3341413,18.1182615 L15.3341413,15.6509522 L14.2466202,15.6512717 L14.2472592,18.1850319 C14.2472592,18.4495576 14.0328859,18.6642451 13.7680343,18.6642451 C13.5035022,18.6642451 13.2888094,18.4498771 13.2888094,18.1850319 L13.2881704,15.6512717 L12.1581581,15.6515911 L12.1581581,17.4154154 C12.1581581,17.6799411 11.9434654,17.8946286 11.6789332,17.8946286 C11.4144011,17.8946286 11.1997083,17.6799411 11.1997083,17.4154154 L11.1997083,15.6515911 L8.40231278,15.6522301 L8.40231278,16.2087564 C8.40231278,17.2272443 7.57357318,18.0562832 6.55537999,18.0562832 L6.55506051,18.0562832 C5.53782578,18.0553248 4.70940566,17.2275638 4.70780824,16.2109927 L4.70780824,14.1813649 C4.70940566,13.1628769 5.53846474,12.3351159 6.55537999,12.3351159 C7.57485111,12.3351159 8.40231278,13.1635159 8.40231278,14.1813649 L8.40231278,14.6938036 L15.8133662,14.6925257 C15.9402011,14.6925257 16.0622437,14.7430028 16.152338,14.8327754 C16.2424322,14.922548 16.2925911,15.0445877 16.2925911,15.1717389 L16.2925911,18.1182615 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.af4b8261e6139074528e9d17d4c448a8.svg";
export { ForwardRef as ReactComponent };